import { useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { DocumentContext } from '../../../context/documentContext';
import { PdfBufferViewer, PdfBufferViewerHandle } from './pdfBufferViewer';
import { UserContext } from '../../../context/authContext';
import { useSearchParams } from 'react-router-dom';
import { documentTableItem } from '../../../lib/models/interfaces';
import AnalyzedContractViewer from './analyzedContractViewer';
import { PdfViewerAnnotationSelection } from './searchablePdfViewer';
import { PdfFallbackPageItemsByPage } from './search/pdfFallbackSearch';

const AnalyzedContractContainer = () => {
  const { setCurrentDocId, allDocuments } = useContext(DocumentContext);
  const { auth, token } = useContext(UserContext);
  const viewerRef = useRef<PdfBufferViewerHandle | null>(null);
  const [queryParameters] = useSearchParams();
  const [currentDocuments, setCurrentDocument] = useState<documentTableItem[]>(
    []
  );
  const [documentBuffer, setDocumentBuffer] = useState<ArrayBuffer | null>(
    null
  );
  const [fallBackPageItems, setFallBackPageItems] =
    useState<PdfFallbackPageItemsByPage>({});
  const [selectedAnnotationReference, setSelectedAnnotationReference] =
    useState<PdfViewerAnnotationSelection | null>(null);
  const [currentPdfPage, setCurrentPdfPage] = useState<number | null>(null);

  const getRelevantDoc = () => {
    const id = queryParameters.get('documentId');
    const thisDoc = allDocuments.filter((ele) => ele._id === id);

    if (thisDoc) {
      setCurrentDocument(thisDoc);
    }
  };

  const fetchPDFBuffer = async (url: string): Promise<ArrayBuffer> => {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Failed to fetch PDF: ${response.status}`);
    }

    return response.arrayBuffer();
  };

  const getImageFromS3 = async () => {
    if (!token) return;

    try {
      const docId = queryParameters.get('documentId');

      if (!docId) return;

      console.log('getting s3 file for', docId);
      const res = await axios.post(
        `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=getContractPDF`,
        { documentId: docId },
        auth
      );
      const url = res.data.url;
      const buffer = await fetchPDFBuffer(url);

      setDocumentBuffer(buffer);
    } catch (e) {
      console.log('Error from get Image', e);
    }
  };

  useEffect(() => {
    if (queryParameters.get('documentId')) {
      setCurrentDocId(queryParameters.get('documentId')!);
    }

    getImageFromS3();
    getRelevantDoc();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="grid h-[90vh] w-screen max-w-[95vw] grid-cols-2 overflow-hidden bg-white">
      <section
        id="left"
        className="h-full min-h-0 min-w-0 border-r border-slate-200"
      >
        <PdfBufferViewer
          buffer={documentBuffer}
          fileName={currentDocuments[0]?.documentFileName ?? 'document.pdf'}
          ref={viewerRef}
          fallbackPdfPageItems={fallBackPageItems}
          onCurrentPageChange={setCurrentPdfPage}
          onAnnotationReferenceSelect={setSelectedAnnotationReference}
        />
      </section>
      <section
        id="right"
        className="h-[90vh] min-h-0 min-w-0 overflow-x-hidden overflow-y-hidden"
      >
        <AnalyzedContractViewer
          currentPdfPage={currentPdfPage}
          selectedAnnotationReference={selectedAnnotationReference}
          viewerRef={viewerRef}
          setFallbackPageItems={setFallBackPageItems}
        />
      </section>
    </div>
  );
};

export default AnalyzedContractContainer;
